import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getProjectMembers,
  ProjectMemberWithProfile,
} from '@/features/projects/shared/api/get-project-members';

type Props = Omit<
  UseQueryOptions<
    ProjectMemberWithProfile[],
    unknown,
    ProjectMemberWithProfile[]
  >,
  'queryKey' | 'queryFn'
> & {
  projectId: string;
};

export const getProjectMembersQueryKey = (projectId: string) => [
  'projectMembers',
  projectId,
];

export const useProjectMembersQuery = ({ projectId, ...props }: Props) => {
  return useQuery({
    ...props,
    queryKey: getProjectMembersQueryKey(projectId),
    queryFn: () => getProjectMembers({ projectId }),
    enabled: !!projectId,
  });
};
